/** Point 2D pour interpoler un trajet de replay. */
export type PathPoint2D = { x: number; y: number };

/**
 * Position le long d’une polyline à t ∈ [0, 1] (paramètre uniforme par segment).
 * Ease Linear : pas de plateau / freinage entre les sommets.
 */
export function lerpAlongPolyline(points: readonly PathPoint2D[], t: number): PathPoint2D {
  if (points.length === 0) return { x: 0, y: 0 };
  if (points.length === 1) return { x: points[0].x, y: points[0].y };
  const clamped = Math.min(1, Math.max(0, t));
  const maxSeg = points.length - 1;
  const scaled = clamped * maxSeg;
  const i = Math.min(maxSeg - 1, Math.floor(scaled));
  const frac = scaled - i;
  const a = points[i];
  const b = points[i + 1];
  return {
    x: a.x + (b.x - a.x) * frac,
    y: a.y + (b.y - a.y) * frac,
  };
}

/** Index de case le plus proche pour t ∈ [0, 1] le long d’une liste d’indices. */
export function pathIndexAtProgress(indices: readonly number[], t: number): number {
  if (indices.length === 0) return 0;
  if (indices.length === 1) return indices[0];
  const clamped = Math.min(1, Math.max(0, t));
  const maxSeg = indices.length - 1;
  const i = Math.min(maxSeg, Math.round(clamped * maxSeg));
  return indices[i];
}
